export const keyBenefits=[
    {heading:"Extended range",
     paragraph:`Extended range allows you to explore further and ride for longer
     distances. Switch seamlessly between electric and hybrid modes`},
     {heading:"Cost-Effective Operation",
     paragraph:`Reduce more than 90% running cost of the vehicle`},
     {heading:"Hassle-Free Charging",
     paragraph:`Simply plug it into a standard electrical outlet. say goodbye to
     fueling stations and enjoy the convenience of charging at home or
     on the go
     `},
     {heading:"Whisper-Quiet Operation",
     paragraph:`Our Hybrid motorcycle operates almost silently, enhancing your
     connection to the road and providing a peaceful journey.
     `},
     {heading:"Environmentally Friendaly",
     paragraph:`Our electric hybrid vehicle significantly reduces emissions, making
     it an eco-conscious choice for environmentally conscious
     individuals`},
     {heading:"Versatile Riding Mode",
     paragraph:`Our electric hybrid motorcycle offers multiple riding modes,
     allowing you to customise your experience.
     `}
    
];

